import { render } from "./DialogUsedCouponCode.vue?vue&type=template&id=f9a1b282"
import script from "./DialogUsedCouponCode.vue?vue&type=script&lang=js"
export * from "./DialogUsedCouponCode.vue?vue&type=script&lang=js"
script.render = render

export default script